<template>
    <div class="panel-list-new row review-component">
        <b-card class="col-lg-10 offset-lg-1">
            <div class="panel-list">
                <div class="panel-body">
                    <b-row class="panel-title">
                        <div class="text-right">
                            <button v-if="CanGoToSection" class="btn btn-link"
                                @click="GotoSection('Agency/HFM Info')">
                                <b-img class="edit-icon" :src="editIcon" />Agency/HFM Info
                            </button>
                        </div>
                    </b-row>
                    <b-row class="panel-content">
                        <b-col cols="lg-4">
                            <label>Legal Entity</label>
                            <p>
                                {{ ReportingEntity.EntityName }}
                            </p>
                        </b-col>
                        <b-col cols="lg-4">
                            <label>AGENCY</label>
                            <p>
                                {{ ReportingEntity.AgencyName }}
                            </p>
                        </b-col>
                        <b-col cols="lg-4">
                            <label>Location</label>
                            <p>
                                {{ ReportingEntity.Location }}
                            </p>
                        </b-col>
                        <b-col cols="lg-4">
                            <label>Department</label>
                            <p>
                                {{ ReportingEntity.Department }}
                            </p>
                        </b-col>
                        <b-col cols="lg-4">
                            <label>Suggested Entity</label>
                            <p>
                                {{ ReportingEntity.SuggestedEntity }}
                            </p>
                        </b-col>
                        <b-col cols="lg-4">
                            <label>HFM Entity/Hyperion</label>
                            <p>
                                {{ ReportingEntity.HFMEntity }}
                            </p>
                        </b-col>
                    </b-row>
                </div>
                <div class="panel-body">
                    <b-row class="panel-title">
                        <div class="text-right">
                            <button v-if="CanGoToSection" class="btn btn-link"
                                @click="GotoSection('Reporting Info')">
                                <b-img class="edit-icon" :src="editIcon" />Reporting Info
                            </button>
                        </div>
                    </b-row>
                    <b-row class="panel-content">
                         <b-col cols="lg-4">
                            <label>Is this a change in existing reporting entity?</label>
                            <p>
                                {{ ReportingEntity.IsChangeInReportingEntity == true ? 'YES' : 'NO' }}
                            </p>
                        </b-col>
                        <b-col cols="lg-4" v-if="ReportingEntity.IsChangeInReportingEntity === false">
                            <label>Is there media associated with this new reporting entity?</label>
                            <p>
                                {{ReportingEntity.IsMediaAssociated == true ? 'YES' : 'NO'}}
                            </p>
                        </b-col>
                        <b-col cols="lg-4" v-if="ReportingEntity.IsMediaAssociated === true && ReportingEntity.IsChangeInReportingEntity === false">
                            <label>Is there an existing media office already set up in MO?</label>
                            <p>
                                {{ReportingEntity.IsMediaOfficeSetUpInMO == true ? 'YES' : 'NO'}}
                            </p>
                        </b-col>
                        <b-col cols="lg-4" v-if="ReportingEntity.IsChangeInReportingEntity === false">
                            <label>Will this reporting entity be required in Reach?</label>
                            <p>
                                {{ ReportingEntity.IsRequiredInReach == true ? 'YES' : 'NO' }}
                            </p>
                        </b-col>
                           <b-col cols="lg-4" v-if="ReportingEntity.IsChangeInReportingEntity === true">
                            <label>Please indicate the current HFM entity that this maps to</label>
                            <p>
                                {{ ReportingEntity.CurrentHFMEntity }}
                            </p>
                        </b-col>
                        <b-col cols="lg-4" v-if="ReportingEntity.IsChangeInReportingEntity === true">
                            <label>Also, please indicate any existing alternate subsets or roll ups you need this removed from</label>
                            <p>
                                {{ ReportingEntity.ExistingRollupsToRemove }}
                            </p>
                        </b-col>
                        <b-col cols="lg-4">
                            <label>If you would like this to be included in any alternate subsets or roll ups please indicate here</label>
                            <p>
                                {{ ReportingEntity.AlternateSubsetsOrRollups }}
                            </p>
                        </b-col>                 
                    </b-row>
                </div>
            </div>
            <div class="d-block col-lg-10 agree-checkbox agree-checkbox-new">
                <b-form-checkbox value="true" v-model="ReportingEntity.Attestation">By checking this box, the requestor is confirming they have conducted all acceptable measures of due diligence to ensure that the information contained on the form is accurate to the best of their knowledge.
                </b-form-checkbox>
            </div>
        </b-card>
        <b-form-group class="footer-buttons text-right">
            <button class="btn custom-button btn-link" @click="Cancel()">
                Cancel
            </button>
            <button class="btn custom-button btn-primary" v-if="CanGoToSection" @click="Previous()">
                BACK
            </button>

            <button class="btn custom-button btn-primary" :disabled="!IsFormSigned" v-if="!Edit" @click="Submit()">
                Submit
            </button>
            <button class="btn custom-button btn-primary" :disabled="!IsFormSigned" v-if="CanResubmit"
                @click="Resubmit()">
                Resubmit
            </button>
        </b-form-group>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
export default {
    data() {
        return {
            editIcon: require("@/assets/Icons/edit.svg"),
            addIcon: require("@/assets/Icons/add.svg"),
        };
    },
    props: {
        id: {
            type: Number,
            required: false,
        }
    },
    computed: {
        ...mapGetters('reportingEntity', {
            ReportingEntity: 'ReportingEntity',
        }),
        IsFormSigned() {
            return this.ReportingEntity.Attestation == true || this.ReportingEntity.Attestation == 'true';
        },
        IsEdit() {
            return this.id && !isNaN(this.id) && parseInt(this.id) > 0 ? true : false;
        },
        CanResubmit() {
            return (this.id && parseInt(this.id) > 0);
        },
        Edit() {
            return this.id && parseInt(this.id) > 0;
        },
        CanGoToSection() {
            return !this.IsEdit || this.CanResubmit;
        },
    },
    activated() {
        this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
    },
    methods: {
        Submit() {
            let reportingEntity = {};
            reportingEntity.ID = 0;
            reportingEntity.LegalEntity = this.ReportingEntity.LegalEntity;
            reportingEntity.EntityName = this.ReportingEntity.EntityName;
            reportingEntity.Agency = this.ReportingEntity.Agency;
            reportingEntity.AgencyName = this.ReportingEntity.AgencyName;
            reportingEntity.Location = this.ReportingEntity.Location;
            reportingEntity.Department = this.ReportingEntity.Department;
            reportingEntity.SuggestedEntity = this.ReportingEntity.SuggestedEntity;
            reportingEntity.IsMediaAssociated = this.ReportingEntity.IsMediaAssociated;
            reportingEntity.IsMediaOfficeSetUpInMO = this.ReportingEntity.IsMediaOfficeSetUpInMO;
            reportingEntity.IsRequiredInReach = this.ReportingEntity.IsRequiredInReach;
            reportingEntity.IsChangeInReportingEntity = this.ReportingEntity.IsChangeInReportingEntity;
            reportingEntity.AlternateSubsetsOrRollups = this.ReportingEntity.AlternateSubsetsOrRollups;
            reportingEntity.ExistingRollupsToRemove = this.ReportingEntity.ExistingRollupsToRemove;
            reportingEntity.CurrentHFMEntity = this.ReportingEntity.CurrentHFMEntity;
            reportingEntity.HFMEntity = this.ReportingEntity.HFMEntity;
            let formData = new FormData();
            formData.append('request', JSON.stringify(reportingEntity));
            this.$store
                .dispatch("reportingEntity/AddRequest", formData)
                .then(() => {
                    this.$router.push("/ReportingEntity");
                    store.dispatch(
                        "progress/setSuccessMessage",
                        "Your Reporting Entity request has been submitted!"
                    );
                })
                .catch((ex) => {
                    if (ex.response) {
                        var commenmsg = "";
                        if (ex.response.status == 500) {
                            commenmsg = "Please check your inputs or try again later";
                            store.dispatch("progress/setErrorMessage", `${commenmsg}`);
                        } else if (ex.response.status == 503 || ex.response.status == 403 || ex.response.status == 415) {
                            store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                        }else if (ex.response.status == 400) {
                            for (var i = 0; i < ex.response.data.length; i++) {
                                if (ex.response.data[i].ErrorMessage != "undefined") {
                                    commenmsg += ex.response.data[i].ErrorMessage;
                                }
                            }
                            store.dispatch("progress/setErrorMessage", `${commenmsg}`);
                        } else {
                            store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                        }
                    } else {
                        store.dispatch(
                            "progress/setErrorMessage",
                            `Error while creating Reporting Entity request. ${ex}`
                        );
                    }
                });
        },
        Resubmit() {
            let reportingEntity = {};
            reportingEntity.ID=parseInt(this.id);
            reportingEntity.LegalEntity = this.ReportingEntity.LegalEntity;
            reportingEntity.EntityName = this.ReportingEntity.EntityName;
            reportingEntity.Agency = this.ReportingEntity.Agency;
            reportingEntity.AgencyName = this.ReportingEntity.AgencyName;
            reportingEntity.Location = this.ReportingEntity.Location;
            reportingEntity.Department = this.ReportingEntity.Department;
            reportingEntity.SuggestedEntity = this.ReportingEntity.SuggestedEntity;
            reportingEntity.IsMediaAssociated = this.ReportingEntity.IsMediaAssociated;
            reportingEntity.IsMediaOfficeSetUpInMO = this.ReportingEntity.IsMediaOfficeSetUpInMO;
            reportingEntity.IsRequiredInReach = this.ReportingEntity.IsRequiredInReach;
            reportingEntity.IsChangeInReportingEntity = this.ReportingEntity.IsChangeInReportingEntity;
            reportingEntity.AlternateSubsetsOrRollups = this.ReportingEntity.AlternateSubsetsOrRollups;
            reportingEntity.ExistingRollupsToRemove = this.ReportingEntity.ExistingRollupsToRemove;
            reportingEntity.CurrentHFMEntity = this.ReportingEntity.CurrentHFMEntity;
            reportingEntity.HFMEntity = this.ReportingEntity.HFMEntity;
            let formData = new FormData();
            formData.append('request', JSON.stringify(reportingEntity));
            this.$store
                .dispatch("reportingEntity/UpdateReportingEntityRequest", { id: parseInt(this.id), data: formData })
                .then(() => {
                    this.$router.push("/ReportingEntity");
                    store.dispatch(
                        "progress/setSuccessMessage",
                        "Your Reporting Entity request has been updated!"
                    );
                })
                .catch((ex) => {
                    if (ex.response) {
                        var commenmsg = "";
                        if (ex.response.status == 500) {
                            commenmsg = "Please check your inputs or try again later";
                            store.dispatch("progress/setErrorMessage", `${commenmsg}`);
                        } else if (ex.response.status == 503 || ex.response.status == 403 || ex.response.status == 415) {
                            store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                        }else if (ex.response.status == 400) {
                            for (var i = 0; i < ex.response.data.length; i++) {
                                if (ex.response.data[i].ErrorMessage != "undefined") {
                                    commenmsg += ex.response.data[i].ErrorMessage;
                                }
                            }
                            store.dispatch("progress/setErrorMessage", `${commenmsg}`);
                        } else {
                            store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                        }
                    } else {
                        store.dispatch(
                            "progress/setErrorMessage",
                            `Error while updating Reporting Entity request. ${ex}`
                        );
                    }
                });
        },
        Previous() {
            if (this.id) {
                this.$router.push({
                    name: "Reporting Info",
                    params: {
                        id: this.id
                    }
                });
            } else {
                this.$router.push({
                    name: "Reporting Info"
                });
            }
        },
        GotoSection(name) {
            if (this.id) {
                this.$router.push({
                    name: name,
                    params: {
                        id: parseInt(this.id)
                    }
                });
            } else {
                this.$router.push({
                    name: name
                });
            }
        },
        Cancel() {
            this.$router.push("/ReportingEntity");
        },

    },
};
</script>

<style scoped>
span.btn.btn-primary.btn-view {
    height: 0;
    width: 94px;
    min-width: 94px;
    padding: 0;
    margin: 0;
    min-height: 22px;
    font-size: 12px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
}

.add-product-row {
    font-weight: bold;
    padding-left: 0px;
    height: 9px;
    font-family: 'Open Sans';
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.75;
    letter-spacing: normal;
    color: #00a1d2;
}

.panel-list:not(.media-dropdowns) {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
}

.panel-list .panel-body .panel-title {
    border-bottom: 1px solid rgba(151, 151, 151, 0.2);
    width: 100%;
    margin-left: 0px;
    margin-bottom: 25px !important;
}

.panel-list .panel-body .panel-title label {
    color: #77a2bb;
    margin-bottom: 0px !important;
    padding-top: 13px !important;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.57;
    letter-spacing: normal;
    padding-left: 0px !important;
    min-height: 35px;
}

.panel-list .panel-body .panel-title .btn {
    padding-left: 5px;
    padding-right: 5px;
}

.panel-list .panel-body .panel-title>div {
    padding-right: 0px !important;
    float: right;
    font-family: "Open Sans";
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.75;
    letter-spacing: normal;
    color: #00a1d2;
}

.panel-list .panel-content label {
    text-transform: uppercase;
    color: #2c3865;
    font-size: 12px;
    margin-bottom: 1px !important;
    padding-left: 0px;
}

.panel-list .panel-content p {
    text-transform: uppercase;
    color: #4d5161;
    font-size: 14px;
    font-weight: 600;
}

.panel-content.row>div>label:first-child {
    color: #A2A9AD !important;
    font-family: "Open Sans" !important;
    font-size: 10px;
    font-weight: 600 !important;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.42;
    letter-spacing: normal;
}

.panel-content.row>div> :not(:first-child) {
    font-family: "Open Sans" !important;
    font-size: 14px !important;
}

.panel-content.row>div>div {
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #4d5161;
}

.panel-list>.panel-body {
    margin-top: 1rem !important;
}

.panel-content.row>div {
    margin-bottom: 10px !important;
}

.edit-icon {
    height: 11px;
    width: 11px;
    color: #00a1d2;
}

.agree-checkbox.agree-checkbox-new .custom-control-label {
    font-weight: 400;
    font-size: 12px;
    text-transform: none !important;
}
</style>
